export default __webpack_public_path__ + "static/media/bg.d620e59c.svg";